export const Keyboard = {
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  TAB: 9,
};
export const NavigationKeys = [Keyboard.TAB, Keyboard.ARROW_LEFT, Keyboard.ARROW_RIGHT, Keyboard.ARROW_DOWN, Keyboard.ARROW_UP];